function UserModalController(accountService, toasterService, eventService, userService, __env) {
  const ctrl = this;
  const env = __env;
  const hasSelectedGroups = () => Boolean(ctrl.account?.userGroups?.length);

  ctrl.$onInit = () => {
    ctrl.isCurrentUser = ctrl.resolve.currentUser;
    ctrl.edit = ctrl.resolve.type === 'edit';
    ctrl.view = ctrl.resolve.type === 'view';
    ctrl.userGroups = angular.copy(ctrl.resolve.userGroups);
    if (ctrl.edit || ctrl.view) {
      ctrl.account = angular.copy(ctrl.resolve.account);
    } else {
      ctrl.account = {
        userGroups: [],
      };
    }
    ctrl.hasModifyEkeAdmin = userService.hasModifyEkeAdmin();
    ctrl.isEditedUserAdmin = false;
    ctrl.hasSelectedGroups = hasSelectedGroups;
    ctrl.groupSelectionTouched = false;
    processUserGroups();
    ctrl.isShowingDeleteConfirmation = false;
  };

  const processUserGroups = () => {
    if (!ctrl.account.userGroups || !ctrl.userGroups) return;
    ctrl.userGroups.map(g => {
      g.disabled = Boolean(g.name === "EKE_ADMIN" && !ctrl.hasModifyEkeAdmin);
      ctrl.account.userGroups.forEach(group => {
        if (g.id === group.id) {
          g.checked = true;
          if (g.name === "EKE_ADMIN") {
            ctrl.isEditedUserAdmin = true;
          }
          return false;
        }
      });
    });
  };

  ctrl.checkGroup = group => {
    ctrl.groupSelectionTouched = true;
    if (Boolean(ctrl.account.userGroups.find(g => g.id === group.id))) {
      ctrl.account.userGroups = ctrl.account.userGroups.filter(g => g.id !== group.id);
    } else {
      if (group.name.includes('PIS')) {
        // Prevent multiple PIS groups from being checked.
        // User can only have one PIS-group.
        ctrl.account.userGroups = ctrl.account.userGroups.filter(g => !g.name.includes("PIS"));
      }
      ctrl.account.userGroups.push({id: group.id, name: group.name});
    }

    // Update checked groups.
    ctrl.userGroups.forEach(g => {
      g.checked = Boolean(ctrl.account.userGroups.find(g2 => g2.id === g.id));
    });
  };

  ctrl.confirmDeleteUser = function (account) {
    const params = { id: account.id }
    accountService.delete(params).then(
      response => {
        handleUserDeletionResponse(response);
    })
  }

  ctrl.cancelDeleteUser = function () {
    ctrl.isShowingDeleteConfirmation = false;
  }

  ctrl.openUserDeleteConfirmation = function() {
    ctrl.isShowingDeleteConfirmation = true;
  };

  const handleUserDeletionResponse = (response) => {
    if (response.statusCode === 204 || response.statusCode === 200) {
      toasterService.success('', 'User deleted successfully!');
      eventService.trigger('accounts.update');
      ctrl.closeModal();
    } else {
      const message = response.data;
      const code = response.statusCode;
      toasterService.error('', 'User deletion failed with code: ' + code +  ' Message: ' + message); 
    }
  } 

  ctrl.createUser = () => {
    ctrl.groupSelectionTouched = true;
    if (!hasSelectedGroups()) {
      toasterService.error('toaster.add-account', 'toaster.account-groups-required');
      return;
    }

    accountService.create(ctrl.account).then(response => {
      if (response.status && response.status !== 200) {
        toasterService.error('toaster.add-account', 'toaster.add-account-failure');
        return;
      }
      toasterService.success('toaster.add-account', 'toaster.add-account-successful');
      eventService.trigger('accounts.update');
      ctrl.closeModal();
    });
  };

  ctrl.updateUser = () => {
    accountService.update(ctrl.account).then(response => {
      if (response.status && response.status !== 200) {
        toasterService.error('toaster.edit-account', 'toaster.edit-account-failure');
        return;
      }
      toasterService.success('toaster.edit-account', 'toaster.edit-account-successful');
      eventService.trigger('accounts.update');
      ctrl.closeModal();
    });
  };

  ctrl.closeModal = () => {
    ctrl.dismiss({$value: 'cancel'});
  };
}

angular
  .module('users.module')
  .controller('UserModalController', UserModalController);